import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { BaseModalComponent } from './components/base-modal/base-modal.component';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { FormsModule } from '@angular/forms';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { FocusInputDirective } from './directives/focus-input.directive';
import { SharedUiIconsModule } from '@shared/ui/icons';

@NgModule({
  imports: [CommonModule, SharedUiButtonsModule, FormsModule, SharedUiIconsModule],
  declarations: [ConfirmModalComponent, BaseModalComponent, DeleteModalComponent, FocusInputDirective],
  exports: [ConfirmModalComponent, BaseModalComponent, DeleteModalComponent],
})
export class SharedUiModalModule {}
